angular
    .module("skillBuilderSaaS")
    .directive("sbPauseEmails", [function () {
        return {
            restrict: "EA",
            templateUrl: "app/templates/sbPauseEmailsTemplate.html",
            controller: ["authService", "pauseLearnerEmailService", function (authService, pauseLearnerEmailService) {
                    var pauseEmailsVm = this;
                    pauseEmailsVm.isSuperAdmin = authService.isSuperAdmin();
                    pauseLearnerEmailService.getData().then(function (data) {
                        pauseEmailsVm.emailData = data;
                        pauseEmailsVm.pauseStateLoaded = true;
                    });
                    pauseEmailsVm.pauseLearnerEmails = function () {
                        pauseLearnerEmailService.openPauseSettings();
                    };
                }],
            controllerAs: "pauseEmailsVm"
        };
    }]);
